import ApiBase from "@core/Api/api-base";
import { fetchRemote, fetchRemoteResult,  postOpts} from '../../Api/api-util';
import _ from 'lodash';

const apiEndpoint = '/api/Operator/';
const controllerEndpoint = '/Operator/';

export default {
    getSchemes() {
        return fetchRemoteResult(`${apiEndpoint}Schemes`);
    },
    runScheme(id, json = null) {

        const model = {
            schemeId: id,
            revision: null,
            json: json
        };

        return new Promise((resolve, reject) => {
            fetch(
                `${apiEndpoint}Test`,  
                _.merge({}, postOpts, { body: JSON.stringify(model) })
            ).then((response) => {
                if(response.ok) {
                    response.json().then(
                        (value) => resolve(value)
                    );
                } else {
                    response.json().then(
                        (value) => {
                            reject({
                                code: response.status, 
                                type: response.statusText, 
                                value: value
                            });
                        }
                    );
                }
            });
        });
    },
    validateScheme(schemeId, revision){
        const params = { schemeId: schemeId };
        
        if(revision) {
            params.revision = revision;
        }
        
        return fetchRemoteResult(`${controllerEndpoint}ValidateScheme?${ApiBase.parameterize(params)}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
    },
    getLogs(schemeId) {
        return fetchRemoteResult(`${apiEndpoint}Logs?schemeId=${schemeId}`);
    },
    clearCache() {
        return fetchRemote(`${apiEndpoint}ClearCache?olderThanMinutes=0`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
    }
};
